import { takeEvery, put, call } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
  GET_TASK_BY_ID,
  POST_TASK_DOC,
  GET_TASK_DOC,
  POST_COMMENT,
  UPDATE_COMMENT,
  UPDATE_ADMIN_COMMENT,
  CHANGE_TASK_STATUS,
  EXPORT_TASK_DATA,
  UPDATE_STAFF_TIMMING,
  INSERT_STAFF_TIMMING,
  DELETE_BULK_TASK,
  DELETE_TASK_DESCRIPTION,
  UPDATE_TASK_DESCRIPTION,
  EDIT_VEHICLE_DETAILS_BY_ADMIN,
  CLOCK_IN_RESTRICTION,
  GET_PARTICIPANT_LOCATIONS,
  DELETE_TASK_DOCS,
  TASK_LOGS,
  TEAM_TASK_DETAIL,
  TEAM_ENTER_TASK_PROGRESS_NOTE,
  RATE_TASK,
  SEND_RATE_TASK_EMAIL,
  GET_EVENTS_LIST,
} from "./actionTypes";
import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  getCategoriesSuccess,
  getCategoriesFail,
  getTaskIdSuccess,
  getTaskIdFail,
  postTaskDocFail,
  postTaskDocSuccess,
  getTaskDocsFail,
  getTaskDocsSuccess,
  addCommentSuccess,
  addCommentFail,
  updateCommentFail,
  updateCommentSuccess,
  updateCommentAdminFail,
  updateCommentAdminSuccess,
  changeTaskStatusFail,
  changeTaskStatusSuccess,
  exportTaskDataFail,
  exportTaskDataSuccess,
  updateStaffTimmingSuccess,
  updateStaffTimmingFail,
  insertStaffTimmingFail,
  insertStaffTimmingSuccess,
  deleteBulkTaskSuccess,
  deleteBulkTaskFail,
  deleteTaskDescriptionFail,
  deleteTaskDescriptionSuccess,
  updateTaskDescriptionFail,
  updateTaskDescriptionSuccess,
  editVehicleDetailsSuccess,
  editVehicleDetailsFail,
  clockInRestrictionSuccess,
  clockInRestrictionFail,
  getParticipantLocationSuccess,
  getParticipantLocationFail,
  deleteTaskDocsSuccess,
  deleteTaskDocsFail,
  getTaskDocs,
  taskLogsSuccess,
  taskLogsFail,
  getTeamTaskDetailFail,
  getTeamTaskDetailSuccess,
  enterTeamProgressNoteSuccess,
  enterTeamProgressNoteFail,
  rateTaskSuccess,
  rateTaskFail,
  sendTaskRateEmailSuccess,
  sendTaskRateEmailFail,
  getEventsListSuccess,
  getEventsListFail,
} from "./actions";

import {
  postComment,
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
  getTaskDetails,
  postTaskDocuments,
  getTaskDocslist,
  updateComment,
  updateAdminNote,
  updateTaskStatus,
  getExportTaskData,
  updateStaffActionTime,
  deleteMultipleTasks,
  insertStaffActionTime,
  deleteTaskDesc,
  updateTaskDesc,
  editAdminVehicleDetails,
  clockInRestrictionApi,
  fetchParticipants,
  onDeletingTaskDocs,
  onGettingLogs,
  onGettingTeamTaskDetail,
  onEnteringTeamNotes,
  onRatingTask,
  onSendTaskRateEmail,
  getEventsList,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Tasks";

function* ClockIn_Restriction({ payload: data }) {
  try {
    const response = yield call(clockInRestrictionApi, data);
    if (response?.status) {
      yield put(clockInRestrictionSuccess(response));
      showToast("success", "Clock-in Restriction", response.message);
    } else {
      yield put(clockInRestrictionFail(response.message));
      showToast("warning", "Clock-in Restriction", response.message);
    }
  } catch (error) {
    yield put(clockInRestrictionFail(error));
    showToast("error", "Clock-in Restriction", error);
  }
}

function* onDeleteTaskDocs({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onDeletingTaskDocs, data);
    if (response?.status) {
      yield put(deleteTaskDocsSuccess(response));
      showToast("success", "Task Documents", response.message);
      dispatch(getTaskDocs({ task_id: data?.task_id }));
    } else {
      yield put(deleteTaskDocsFail(response.message));
      showToast("warning", "Task Documents", response.message);
    }
  } catch (error) {
    yield put(deleteTaskDocsFail(error));
    showToast("error", "Task Documents", error);
  }
}

function* Edit_Admin_Vehicle_Details({ payload: data }) {
  try {
    const response = yield call(editAdminVehicleDetails, data);
    if (response?.status) {
      yield put(editVehicleDetailsSuccess(response));
      showToast("success", "Vehicle Details", response.message);
    } else {
      yield put(editVehicleDetailsFail(response.message));
      showToast("warning", "Vehicle Details", response.message);
    }
  } catch (error) {
    yield put(editVehicleDetailsFail(error));
    showToast("error", "Vehicle Details", error);
  }
}

function* onGetLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingLogs, data);
    yield call(responseHandler, toastTitle, response, taskLogsSuccess, taskLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(editVehicleDetailsFail(error));
    showToast("error", "Vehicle Details", error);
  }
}

function* Delete_Task_Desc({ payload: data }) {
  try {
    const response = yield call(deleteTaskDesc, data);
    if (response?.status) {
      yield put(deleteTaskDescriptionSuccess(response));
      showToast("success", "Description", response.message);
    } else {
      yield put(deleteTaskDescriptionFail(response.message));
      showToast("warning", "Description", response.message);
    }
  } catch (error) {
    yield put(deleteTaskDescriptionFail(error));
    showToast("error", "Description", error);
  }
}
function* Update_Task_Desc({ payload: data }) {
  try {
    const response = yield call(updateTaskDesc, data);
    if (response?.status) {
      yield put(updateTaskDescriptionSuccess(response));
      showToast("success", "Description", response.message);
    } else {
      yield put(updateTaskDescriptionFail(response.message));
      showToast("warning", "Description", response.message);
    }
  } catch (error) {
    yield put(updateTaskDescriptionFail(error));
    showToast("error", "Description", error);
  }
}
function* onUpdateStatus({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateTaskStatus, data);
    yield call(responseHandler, "Task Status", response, changeTaskStatusSuccess, changeTaskStatusFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(changeTaskStatusFail(error));
    showToast("error", "Task", error);
  }
}

function* Get_Participant_Location({ payload: data }) {
  try {
    const response = yield call(fetchParticipants, data);
    yield put(getParticipantLocationSuccess(response));
  } catch (error) {
    yield put(getParticipantLocationFail(error));
    showToast("error", "Fetch Partipant location", error);
  }
}

function* Add_Comment({ payload: data }) {
  try {
    const response = yield call(postComment, data);
    yield put(addCommentSuccess(response));
  } catch (error) {
    yield put(addCommentFail(error));
  }
}
function* Update_Admin_Comment({ payload: data }) {
  try {
    const response = yield call(updateAdminNote, data);
    yield put(updateCommentAdminSuccess(response));
    showToast("success", "Note", response.message);
  } catch (error) {
    yield put(updateCommentAdminFail(error));
    showToast("error", "Note", error);
  }
}
function* Update_Comment({ payload: data }) {
  try {
    const response = yield call(updateComment, data);
    yield put(updateCommentSuccess(response));
    showToast("success", "Note", "Note Updated Successfully");
  } catch (error) {
    yield put(updateCommentFail(error));
    showToast("error", "Note", error);
  }
}

function* GetDocs({ payload: data }) {
  try {
    const response = yield call(getTaskDocslist, data);
    yield put(getTaskDocsSuccess(response));
  } catch (error) {
    yield put(getTaskDocsFail(error));
  }
}

function* UploadDoc({ payload: data }) {
  try {
    const response = yield call(postTaskDocuments, data);
    yield put(postTaskDocSuccess(response));
    showToast("success", "Task", "Documents Uploaded Successfully");
  } catch (error) {
    yield put(postTaskDocFail(error));
    showToast("error", "Task", error);
  }
}

function* fetchEventsById({ payload: data }) {
  try {
    const response = yield call(getTaskDetails, data);
    yield put(getTaskIdSuccess(response));
  } catch (error) {
    yield put(getTaskIdFail(error));
  }
}

function* fetchEvents({ payload: data }) {
  try {
    const response = yield call(getEvents, data);
    yield put(getEventsSuccess(response));
  } catch (error) {
    yield put(getEventsFail(error));
  }
}

function* onAddNewEvent({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(addNewEvent, data);
    yield call(responseHandler, toastTitle, response, addEventSuccess, addEventFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addEventFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdateEvent({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateEvent, data);
    yield call(responseHandler, toastTitle, response, updateEventSuccess, updateEventFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateEventFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(deleteEvent, data);
    yield call(responseHandler, "Deleting Task", response, deleteEventSuccess, deleteEventFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteEventFail(error));
    showToast("error", "Task", error);
  }
}

function* onGetCategories() {
  try {
    const response = yield call(getCategories);
    yield put(getCategoriesSuccess(response));
  } catch (error) {
    yield put(getCategoriesFail(error));
  }
}

function* fetch_export_task_data({ payload: data }) {
  try {
    const response = yield call(getExportTaskData, data);
    yield put(exportTaskDataSuccess(response));
  } catch (error) {
    yield put(exportTaskDataFail(error));
  }
}

function* Insert_Staff_Timmings({ payload: data }) {
  try {
    const response = yield call(insertStaffActionTime, data);
    yield put(insertStaffTimmingSuccess(response));
    showToast("success", "Updating Timing", response.message);
  } catch (error) {
    yield put(insertStaffTimmingFail(error));
    showToast("error", "Updating Timing", error);
  }
}

function* Update_Staff_Timmings({ payload: data }) {
  try {
    const response = yield call(updateStaffActionTime, data);
    yield put(updateStaffTimmingSuccess(response));
    showToast("success", "Updating Timing", response.message);
  } catch (error) {
    yield put(updateStaffTimmingFail(error));
    showToast("error", "Updating Timing", error);
  }
}

function* Delete_Multiple_Tasks({ payload: data }) {
  try {
    const response = yield call(deleteMultipleTasks, data);
    yield put(deleteBulkTaskSuccess(response));
    showToast("success", "Deleting Tasks", response.message);
  } catch (error) {
    yield put(deleteBulkTaskFail(error));
    showToast("error", "Deleting Tasks", error);
  }
}

function* onGetTeamTaskDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTeamTaskDetail, data);
    yield call(responseHandler, "Task Details", response, getTeamTaskDetailSuccess, getTeamTaskDetailFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getTeamTaskDetailFail(error));
    showToast("error", "Task Detail", error);
  }
}

function* onEnterTeamNotes({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onEnteringTeamNotes, data);
    yield call(responseHandler, "Progess Notes", response, enterTeamProgressNoteSuccess, enterTeamProgressNoteFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(enterTeamProgressNoteFail(error));
    showToast("error", "Progess Notes", error);
  }
}

function* onRateTask({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRatingTask, data);
    yield call(responseHandler, "Rating to notes", response, rateTaskSuccess, rateTaskFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(rateTaskFail(error));
    showToast("error", "Progess Notes", error);
  }
}

function* onEmailRateTask({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSendTaskRateEmail, data);
    yield call(responseHandler, "Email to employee", response, sendTaskRateEmailSuccess, sendTaskRateEmailFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(sendTaskRateEmailFail(error));
    showToast("error", "Email to employee", error);
  }
}

function* onGettingTaskList({ payload }) {
  try {
    const response = yield call(getEventsList, payload);
    yield put(getEventsListSuccess(response));
  } catch (error) {
    yield put(getEventsListFail(error));
    showToast("error", "Task List", error);
  }
}
function* calendarSaga() {
  yield takeEvery(GET_EVENTS_LIST, onGettingTaskList);
  yield takeEvery(SEND_RATE_TASK_EMAIL, onEmailRateTask);
  yield takeEvery(RATE_TASK, onRateTask);
  yield takeEvery(GET_EVENTS, fetchEvents);
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent);
  yield takeEvery(UPDATE_EVENT, onUpdateEvent);
  yield takeEvery(DELETE_EVENT, onDelete);
  yield takeEvery(GET_CATEGORIES, onGetCategories);
  yield takeEvery(GET_TASK_BY_ID, fetchEventsById);
  yield takeEvery(POST_TASK_DOC, UploadDoc);
  yield takeEvery(GET_TASK_DOC, GetDocs);
  yield takeEvery(POST_COMMENT, Add_Comment);
  yield takeEvery(UPDATE_COMMENT, Update_Comment);
  yield takeEvery(UPDATE_ADMIN_COMMENT, Update_Admin_Comment);
  yield takeEvery(CHANGE_TASK_STATUS, onUpdateStatus);
  yield takeEvery(EXPORT_TASK_DATA, fetch_export_task_data);
  yield takeEvery(UPDATE_STAFF_TIMMING, Update_Staff_Timmings);
  yield takeEvery(INSERT_STAFF_TIMMING, Insert_Staff_Timmings);
  yield takeEvery(DELETE_BULK_TASK, Delete_Multiple_Tasks);
  yield takeEvery(DELETE_TASK_DESCRIPTION, Delete_Task_Desc);
  yield takeEvery(UPDATE_TASK_DESCRIPTION, Update_Task_Desc);
  yield takeEvery(EDIT_VEHICLE_DETAILS_BY_ADMIN, Edit_Admin_Vehicle_Details);
  yield takeEvery(CLOCK_IN_RESTRICTION, ClockIn_Restriction);
  yield takeEvery(GET_PARTICIPANT_LOCATIONS, Get_Participant_Location);
  yield takeEvery(DELETE_TASK_DOCS, onDeleteTaskDocs);
  yield takeEvery(TASK_LOGS, onGetLogs);
  yield takeEvery(TEAM_TASK_DETAIL, onGetTeamTaskDetail);
  yield takeEvery(TEAM_ENTER_TASK_PROGRESS_NOTE, onEnterTeamNotes);
}

export default calendarSaga;
